import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";

import sal from "sal.js";

import ToolData from "../../data/header.json";
import {useRouter} from 'next/router';
const CallToAction = ({messages}) => {
  const router = useRouter();
  useEffect(() => {
    sal();
  }, []);

  const [Assistants, SetAssistants] = useState([]);

  useEffect(() => {
    async function fecthAI() {
      const response = await fetch("/api/home_ai");
      const data = await response.json();
      SetAssistants(data);
    }
    fecthAI();
  }, [])
  

  return (
    <>
      <div className="rainbow-callto-action-area">
        <div className="wrapper">
          <div className="rainbow-callto-action clltoaction-style-default rainbow-section-gap">
            <div className="container">
              <div className="row row--0">
                <div className="col-lg-12">
                  <div className="align-items-center content-wrapper">
                    <div className="inner">
                      <div className="content text-center">
                        <span className="theme-gradient b2 mb--30 d-inline-block">
                          {messages["call-to-action-title"]}
                        </span>
                        <h2
                          className="title"
                          data-sal="slide-up"
                          data-sal-duration="400"
                          data-sal-delay="200"
                        >
                          {messages["call-to-action-desc"]}
                        </h2>
                        <p
                          className="description"
                          data-sal="slide-up"
                          data-sal-duration="400"
                          data-sal-delay="300"
                        >
                          {messages["call-to-action-small-text"]}
                        </p>
                        <div
                          className="call-to-btn"
                          data-sal="slide-up"
                          data-sal-duration="400"
                          data-sal-delay="350"
                        >
                          <Link
                            className="btn-default bg-light-gradient btn-large"
                            href={messages["call-to-action-href"]}
                          >
                            <div className="has-bg-light"></div>
                            <span>{messages["call-to-action-btn"]}</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="fancy-genearate-section">
            <div className="container">
              <div className="genarator-section">
                <ul className="genarator-card-group full-width-list">
                  {Assistants &&
                    Assistants.slice(0, 5).map((data, index) => (
                      <li key={index}>
                        <Link
                          href={`/ai/${data.slug}`}
                          className="genarator-card bg-flashlight-static center-align"
                        >
                          <div className="inner">
                            <div className="left-align">
                              <div className="img-bar">
                                <img
                                  src={`https://aigency.dev/api/images/${data.image}`}
                                  width={data.wdt ? data.wdt : 40}
                                  height={40}
                                  alt="AI Generator"
                                />
                              </div>
                              <h5 className="title">{JSON.parse(data.name)["name_"+router.locale]}</h5>
                              <span className="rainbow-demo-btn">
                                {messages["try-it-now-free"]}
                              </span>
                            </div>
                          </div>
                          {data.badge !== "" ? (
                            <span className="rainbow-badge-card">
                              {data.badges && (() => {
                                  const badges = JSON.parse(data.badges);
                                  if (Array.isArray(badges) && badges[0] && badges[0][router.locale]) {
                                      return badges[0][router.locale];
                                  } 
                              })()}
                            </span>
                          ) : (
                            ""
                          )}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallToAction;
